import { isNumber, isString, isUndefined } from 'lodash';

export type ValueType = string | number;

export const isValueType = (value: unknown): value is ValueType | undefined => {
  return isUndefined(value) || isString(value) || isNumber(value);
};
